export const toDate = (value: Date | string | number): Date =>
  value instanceof Date ? value : new Date(value);
